import { restaurantTabs } from "./restaurant_tabs";
import { initSwiper } from "./carousel";
import { filterCarousel } from "./filter_carousel";
import { glightBox } from "./glightbox";
import { lenis } from './lenis';
import { sd_modal } from './sd_modal/sd_modal';
import { initMobileSwiper } from './carousel/mobile-swiper-carousel'
import { initBlog } from './blog/blog';
import { countdown } from "./countdown";
import { sd_popup } from "./sd_popup/sd_popup";

export const componentRegistry: Record<string, (el: HTMLElement) => void> = {
  "countdown": countdown,
  "carousel": initSwiper,
  "filter-carousel": filterCarousel,
  "glightbox": glightBox,
  "restaurant-tabs": restaurantTabs,
  "sd-modal": sd_modal,
  "smooth-scroll": lenis,
  "sd-popup": sd_popup,
  "mobile-carousel": initMobileSwiper,
  "blog": initBlog,
};
